<template>
  <div class="section-resolution">
    <Section>
      <div class="section-header" slot="header">
        <h1 class="title">Resolution</h1>
      </div>
      <div class="section-body">
        <ColumnChart
          v-if="categories && series && !isEmpty && !isError"
          :graphSeries="series"
          :graphCategories="categories"
        />
        <EmptyMessage v-if="!isLoading && isEmpty && !isError">
          ไม่พบข้อมูลในช่วงเวลาดังกล่าว
        </EmptyMessage>
        <EmptyMessage v-if="!isLoading && isError">
          <h3>พบข้อผิดพลาดระหว่างโหลดข้อมูล</h3>
          <p>
            โปรดรอซักครู่เพื่อโหลดข้อมูลใหม่ หรือติดต่อ
            <a :href="`mailto:support@byteark.com`" target="_top">support@byteark.com</a>
          </p>
          <span slot="code" class="code">error code : {{error.status || 'not found' }} </span>
        </EmptyMessage>
        <div v-if="isLoading" class="d-flex justify-content-center">
          <div class="spinner-border" role="status" />
        </div>
      </div>
    </Section>
  </div>
</template>

<script>
/* eslint-disable arrow-parens */
/* eslint-disable arrow-body-style */
/* eslint-disable prefer-destructuring */

import _ from 'lodash';
import ColumnChart from '@/charts/ColumnChart.vue';
import Section from '@/components/Section.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';

export default {
  props: ['resolutionData', 'isLoading', 'isError', 'error'],
  components: {
    ColumnChart,
    Section,
    EmptyMessage,
  },
  data() {
    return {
      series: [],
      categories: [],
    };
  },
  watch: {
    resolutionData() {
      this.createGraph();
    },
  },
  computed: {
    isEmpty() {
      return _.isEmpty(this.resolutionData);
    },
  },
  methods: {
    async createGraph() {
      Promise.all([this.getResolutionData(), this.getCategoriesData()]).then(
        (values) => {
          this.series = [
            {
              name: '',
              data: values[1],
            },
          ];
          this.categories = values[0];
        },
      );
    },
    async getResolutionData() {
      const seriesData = await _.map(
        this.resolutionData,
        (value) => value.resolution,
      );
      return seriesData;
    },
    async getCategoriesData() {
      const categoriesData = await _.map(
        this.resolutionData,
        (value) => value.playbackIdUniqueCount,
      );
      return categoriesData;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.section-resolution {
  .section {
    min-height: 400px;
    height: 100%;
  }
}

a {
  color: $primary !important;
}
</style>
